import { createContext } from 'react';
import type {
  BrandingSettings,
  GeneralSettings,
  NotificationSettings,
  SecuritySettings,
  SystemSettings,
} from '@/configuration/ConfigurationTypes';

export interface ConfigurationContextValue {
  settings: SystemSettings | null;
  isLoading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
  updateGeneral: (payload: GeneralSettings) => Promise<void>;
  updateNotifications: (payload: NotificationSettings) => Promise<void>;
  updateSecurity: (payload: SecuritySettings) => Promise<void>;
  updateBranding: (payload: BrandingSettings) => Promise<void>;
}

export const ConfigurationContext = createContext<
  ConfigurationContextValue | undefined
>(undefined);
